if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }
      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      /**
       * When the variant is changed,
       * Images of the right color are loaded from the script tags and added to the zoom div, hiding all the others already present.
       * Otherwise, if the images have already been added, those of the right color are selected and all the others are hidden
       */
      updateVariantZoomImg() {

        const parser = new DOMParser();
        let currentColor = this.getAttribute('variant-media-color');
        let imgZoomScript = this.querySelectorAll('.product-media-modal__content script');

        if (imgZoomScript.length > 0) {
          this.updateZoomFromScript(parser, currentColor, imgZoomScript);
        } else {
          this.updateZoomFromHTML(currentColor);
        }

      }

      updateHighZoom() {
        const parser = new DOMParser();
        let currentColor = this.getAttribute('variant-media-color');
        let defaultColor = this.getAttribute('variant-default-color');
        let imgZoomScript = this.querySelectorAll(`.product-media-modal__content script[variant-media-color=${currentColor}]`);

        if (imgZoomScript.length != 0) {
          this.updateZoomFromScript(parser, currentColor, imgZoomScript);
        } else {
          let currentColorImages = this.querySelectorAll(`[data-img-color=${currentColor}]`);
          if (currentColorImages.length != 0) {
            this.updateZoomFromHTML(currentColor);
          } else {
            let defaultScriptColor = this.querySelectorAll(`.product-media-modal__content script[variant-media-color=${defaultColor}]`);
            if (defaultScriptColor.length != 0) {
              this.updateZoomFromScript(parser, defaultColor, defaultScriptColor);
            } else {
              this.updateZoomFromHTML(defaultColor);
            }
          }
        }
      }

      updateActionZoom() {
        const parser = new DOMParser();
        let currentColor = this.getAttribute('variant-media-color');
        let defaultColor = this.getAttribute('variant-default-color');
        let imgZoomScript = this.querySelectorAll(`.product-media-modal__content script[variant-media-color=${currentColor}]`);

        if (imgZoomScript.length != 0) {
          this.updateZoomFromScript(parser, currentColor, imgZoomScript);
        } else {
          let currentColorImages = this.querySelectorAll(`[data-img-color=${currentColor}]`);
          if (currentColorImages.length != 0) {
            this.updateZoomFromHTML(currentColor);
          } else {
            let defaultScriptColor = this.querySelectorAll(`.product-media-modal__content script[variant-media-color=${defaultColor}]`);
            if (defaultScriptColor.length != 0) {
              this.updateZoomFromScript(parser, defaultColor, defaultScriptColor);
            } else {
              this.updateZoomFromHTML(defaultColor);
            }
          }
        }
      }

      updateZoomFromScript(parser, currentColor, imgZoomScript) {
        this.querySelectorAll('.product-media-modal__content img').forEach(function(element) {
          if (element.getAttribute('data-img-color') != currentColor) {
            element.closest('.product-medial-modal__img-wrapper').style.display="none";
          }
        });

        imgZoomScript.forEach(function(element) {

          let htmlDoc = parser.parseFromString(element.innerHTML, 'text/html');

          if ( element.getAttribute('variant-media-color') == currentColor) {
            element.closest('.product-media-modal__content').appendChild(htmlDoc.querySelector('body > *'));
            element.remove();
          }
        });
      }

      updateZoomFromHTML(currentColor) {

        this.querySelectorAll('.product-media-modal__content img').forEach(function(element) {
          if (element.getAttribute('data-img-color') == currentColor || element.getAttribute('data-img-color') == 'no-color') {
            element.closest('.product-medial-modal__img-wrapper').style.display="block";
          } else {
            element.closest('.product-medial-modal__img-wrapper').style.display="none";
          }
        });
      }

      showActiveMedia() {
        if (this.classList.contains('product-media-modal--default')) {
          this.updateVariantZoomImg();
        }else if (this.classList.contains('product-media-modal--high') || this.classList.contains('product-media-modal--action')){
          this.updateHighZoom();
          this.updateActionZoom();
        }

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
